import ExportViewModel from "./ExportViewModel";
import TripRateCalculationFiltersViewModel from "./TripRateCalculationFiltersViewModel";

export default class TripRateExportViewModel {
    filtersVm: TripRateCalculationFiltersViewModel = new TripRateCalculationFiltersViewModel;
    exportFiltersVm: ExportViewModel = new ExportViewModel;
    selectedSurveys: string[] = [];
    manuallyRemovedSurveysCount: number = 0;
    autoRemovedSurveysCountList: number = 0;
    hourly: boolean = false;
    extrapolate: boolean = false;
    extrapolateValue: number = 0;
    SelectedVehicleType: number = 0;
    startTime: number = 0;
    endTime: number = 0;
}